const messages: string[] = [
  "Coming soon! We're working hard to bring you something amazing. 🚀",
  "Pardon our dust! This page is under construction, but we'll be ready to unveil it soon. 🏗️",
  "Good things come to those who wait. Our team is crafting an exceptional experience for you. ⏳",
  "We're building something exciting! Stay tuned for updates on this page. 🛠️",
  "Shhh... It's not quite ready yet, but we promise it'll be worth the wait! 🤫",
  "We appreciate your patience while we put the finishing touches on this page. 🎨",
  "Exciting developments are happening behind the scenes. Check back soon for the big reveal! 🎉",
  "Our developers are brewing up something special. Stay tuned for the grand unveiling! ☕",
  "We're putting the pieces together to create an incredible experience. Thanks for your patience! 🧩",
  "Rome wasn't built in a day, and neither was this page. But we're making great progress! 🏛️",
  "Innovation is a journey, and we're taking this page to new heights. Hang tight! 🌠",
];

export const getWorkInProgressMessage = (): string => {
  const randomIndex = Math.floor(Math.random() * messages.length);
  const message = messages[randomIndex];
  if (message) {
    return message;
  }
  return "Work in progress...";
};
